import React, { useEffect, useMemo, useState } from 'react';
import { Input, PrimaryButton, SecondaryButton } from 'common/components';
import { useTranslation } from 'react-i18next';
import { Wrapper, InputWrapper, ButtonWrapper, StyledDivider } from './styles';
import {
  resetCOError,
  resetVerifiedOldEmailCode,
} from 'applicaiton/store/reducers/ClinicOwner/ClinicOwnerSlice';
import { useAppDispatch, useAppSelector } from 'common/hooks/redux';
import { clinicOwnerVerifyOldEmail } from 'applicaiton/store/reducers/ClinicOwner/ActionCreators';
import { NewEmailProps } from './modules';

const NewEmail = ({ onNext, onCancel }: NewEmailProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const newEmail = sessionStorage.getItem('newEmail');
  const [email, setEmail] = useState(newEmail);

  const { error } = useAppSelector((state) => state.clinicOwnerSlice);

  useEffect(() => {
    dispatch(resetVerifiedOldEmailCode());

    return () => {
      dispatch(resetCOError());
    };
  }, []);

  const handleNext = () => {
    dispatch(
      clinicOwnerVerifyOldEmail({
        email: String(email),
      }),
    ).then((data) => {
      if (data.meta.requestStatus === 'fulfilled') {
        onNext();
      }
    });
  };

  const emailErrorMessage = useMemo(() => {
    return error.includes('400')
      ? t('user_exist')
      : error
      ? t('error_attempt_limit')
      : '';
  }, [error]);

  return (
    <Wrapper>
      <InputWrapper>
        <Input
          id={'newEmail'}
          placeholder={t('auth.enter_your_email')!}
          type={'email'}
          label={t('email')!}
          onChange={(e) => setEmail(e.target.value)}
          value={email!}
          errorMessage={emailErrorMessage}
        />
      </InputWrapper>
      <StyledDivider />
      <ButtonWrapper>
        <SecondaryButton onClick={onCancel}>{t('cancel')}</SecondaryButton>
        <PrimaryButton onClick={handleNext}> {t('next')}</PrimaryButton>
      </ButtonWrapper>
    </Wrapper>
  );
};

export default NewEmail;
